// extracted by mini-css-extract-plugin
export var explainable = "_k1-a";
export var printerCard = "_k1-1";
export var printerCardConfigured = "_k1-2";
export var printerCardError = "_k1-3";
export var printerCardsContainer = "_k1-0";
export var printerIcon = "_k1-8";
export var printerIconConfigured = "_k1-5";
export var printerIconContainer = "_k1-4";
export var printerIconError = "_k1-6";
export var printerIconUnconfigured = "_k1-7";
export var workstationsTableCard = "_k1-9";